module.exports = __webpack_public_path__ + "static/media/14_tearsofhair.f1ff8104.jpg";